export const CUSTOM_WORKLIST_FILTERS_IN_FLIGHT_KEY = '_customWorklistFiltersInFlight';

export enum WorklistClickAction {
  SINGLE = 'single',
  COMBINED = 'combined',
}
